export const transport = (lng, lat) => {
    let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
    let x = lng - 0.0065;
    let y = lat - 0.006;
    let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    let newlng = z * Math.cos(theta);
    let newlats= z * Math.sin(theta);
    return [newlng, newlats]
}

export const getDistanceByLngLat = (posA, posB, km = false) => {
    // getDistance(double longitude1, double latitude1, double longitude2, double latitude2, boolean km) {
    let [latitude1, longitude1] = posA
    let [latitude2, longitude2] = posB
    let lat1 = ConvertDegreesToRadians(latitude1);
    let lon1 = ConvertDegreesToRadians(longitude1);
    let lat2 = ConvertDegreesToRadians(latitude2);
    let lon2 = ConvertDegreesToRadians(longitude2);

    let vLon = Math.abs(lon1 - lon2);
    let vLat = Math.abs(lat1 - lat2);

    let s = 6371.004 * 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(vLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(vLon / 2), 2)));
    s = Math.round(s * 10000) / 10000;
    if (!km) {
        s = s * 1000;
    }
    console.log('s: '+ s)
    return s.toFixed(2);
}

function ConvertDegreesToRadians(degrees) {
    return degrees * Math.PI / 180.0;
}
function ConvertRadiansToDegrees(degrees) {
    return radian * 180.0 / Math.PI;
}